import React from 'react';
import { useSelector } from 'react-redux';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { getLetterMonthDate } from '../../../../global/helpers/date-helpers';
import { getCurrencyFormat } from '../../../../global/helpers/format-helpers';
import { PlanExtended } from '../../../../Global/models/coverage-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { NewHireProps } from '../../../arc/models/arc-epi-props';

interface Props {
    title: string;    
    plan: PlanExtended;
    planAvailable: boolean;
}

export function ReviewPlanExtendedDisplay(props: Props) {
    const { title, plan, planAvailable } = props;

    const newHireSettings: NewHireProps = useSelector<TcsmStates, NewHireProps>(state => state?.epiProps?.newHireSettingsState?.epiContent);

    if (!planAvailable || !plan) return null;

    return (
        <>
            <ContentSpacer><h3>{title}</h3></ContentSpacer>
            <p>{plan?.planName}</p>            
            
            {plan?.accountNumber && <LabelAndValue label={newHireSettings?.billingAccountLabel} value={plan?.accountNumber} />}
            {(plan?.volume) && <LabelAndValue label={newHireSettings?.volumeLabel} value={getCurrencyFormat(plan?.volume)} />}
            {(plan?.rate) && < LabelAndValue label={newHireSettings?.rateLabel} value={getCurrencyFormat(plan?.rate)} />}
            {plan?.effectiveDate && < LabelAndValue label={newHireSettings?.effectiveDateLabel} value={getLetterMonthDate(plan?.effectiveDate)} />}
        </>
    );
}
